module.exports = __webpack_public_path__ + "img/sms.dec00493.png";